import { render, staticRenderFns } from "./OnboardPricing.vue?vue&type=template&id=a077b584&scoped=true"
import script from "./OnboardPricing.vue?vue&type=script&lang=ts"
export * from "./OnboardPricing.vue?vue&type=script&lang=ts"
import style0 from "./OnboardPricing.vue?vue&type=style&index=0&id=a077b584&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a077b584",
  null
  
)

export default component.exports